<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="姓名" prop="realName" >
        <a-input v-model="form.realName" placeholder="请输入姓名" disabled="disabled" />
      </a-form-model-item>
      <a-form-model-item label="身份证" prop="idCard" >
        <a-input v-model="form.idCard" placeholder="请输入身份证"  disabled="disabled" />
      </a-form-model-item>
      <a-form-model-item label="身份证正面" prop="idCardFront" >
        <img style="width: 240px;height: 120px;" :src="form.idCardFront"/>
      </a-form-model-item>
      <a-form-model-item label="身份证反面" prop="idCardReverse" >
        <img style="width: 240px;height: 120px;" :src="form.idCardReverse"/>
      </a-form-model-item>
      <a-form-model-item label="状态" prop="status" >
        <a-select v-model="form.status">
          <a-select-option :value="1">待审核</a-select-option>
          <a-select-option :value="2">通过</a-select-option>
          <a-select-option :value="3">拒绝</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="拒绝原因" prop="refuseReason" v-if="form.status && form.status === 3" >
        <a-textarea  v-model="form.refuseReason" placeholder="请输入拒绝原因" :rows="3"  />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getAuthentication, addAuthentication, updateAuthentication } from '@/api/user/authentication'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,

        userId: null,

        realName: null,

        idCard: null,

        idCardFront: null,

        idCardReverse: null,

        status: 0,

        refuseReason: null,

        cateName: null,

        createTime: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        cateName: [
          { required: true, message: '分类名称不能为空', trigger: 'blur' }
        ],
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        userId: null,
        realName: null,
        idCard: null,
        idCardFront: null,
        idCardReverse: null,
        status: 0,
        refuseReason: null,
        cateName: null,
        createTime: null,
        remark: null,
      }
      this.$nextTick(() => {
        this.$refs.form.resetFields()
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getAuthentication({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateAuthentication(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addAuthentication(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
